import React from "react";
import borderlandsLogo from "../../../assets/images/portfolio/borderlands-echovision-logo.png";
import borderlands from "../../../assets/images/portfolio/borderlands-lg.png";
import streaming from "../../../assets/images/portfolio/project-genvid-streaming.png";

export default function ProfessionalProjects() {
    return (
        <section id="proProjectsBorderlands" className="proProjects__container borderlands__container anchor ">
            <div className="projects__yellowFlourish"></div>
            {/* Projects List */}
            <div className="container">
                <div className="box row projects__row borderlands__row">
                    <div className="proProjects__textBox col-lg-7 col-md-12 col-sm-12 col-12 order-lg-1 order-md-2 order-sm-2 order-2">
                        <p className="proProjects__projectTitle">Massively Interactive Streaming Platform</p>
                        <p className="proProjects__description">My team built and worked on Genvid's proprietary streaming platform serving 20 million concurrent users. I recruited and led the team building the backend foundation and a unqiue interactive frontend. We integrated Genvid's SDK to broadcast gameplay, minigames, chat, and more.</p>
                        <p className="proProjects__description">I handled hiring for developers, QA, project managers, and producers, driving early best practices, coaching, delivering milestones, and also filling in on project management and production.</p>
                        <p className="proProjects__description">We built and operated the platform using AWS services, React, Node.js, real-time streaming pipelines, CI/CD automation, and scalable backend services designed for high concurrency.</p>
                        <div className="primary-button__container">
                            <div className="proProject__capsule capsule">Engineering Mgmt</div>
                            <div className="proProject__capsule capsule">Production</div>
                            <div className="proProject__capsule capsule">Project Mgmt</div>
                        </div>
                        <div className="primary-button__container">
                            <hr className="primary-button__line" />
                            <a
                                href="/project/Genvid"
                                rel="noreferrer"
                            >
                                <button className="primary-button">More Details</button>
                            </a>
                        </div>
                    </div>
                    <div className="proProjects__project-container col-lg-7 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1">
                        <div className="borderlands__imageBlocks">
                            {/* <img
                                src={borderlands}
                                className="proProjects__image proProjects__primary-image"
                                alt="Borderlands: Echovision Live"
                            /> */}
                            {/* <img
                                src={borderlandsLogo}
                                className="proProjects__secondary-image"
                                alt="Borderlands: Echovision Live Logo"
                            /> */}
                            <img
                                src={streaming}
                                className="proProjects__image proProjects__primary-image main__genvid__image"
                                alt="Proprietary Streaming Platform"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
